import React, { Fragment } from "react";
import { TickRenderer } from "../../../../libraries/ReportGenerator/TickRenderer";

const LocationOptions = {
  West: "West",
  East: "East",
  Both: "Both",
};

export const ONR_BeaverDamsReportSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 10,
      columns: [
        {
          title: "Mileage",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "mile",
        },
        {
          title: "Flow of Water",
          colSpan: 4,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "East",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "flow",
             formatter: (val) => TickRenderer(val, LocationOptions.East),
            },
            {
              title: "West",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "flow",
              formatter: (val) => TickRenderer(val, LocationOptions.West),
            },
          ],
        },
        {
          title: "Location of Dam",
          colSpan: 6,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "East",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.East),
            },
            {
              title: "West",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.West),
            },
            {
              title: "Both",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
             formatter: (val) => TickRenderer(val, LocationOptions.Both),
            },
          ],
        },
        {
          title: "Remarks",
          colSpan: 7,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "com",
        },
        {
          title: "Date of Inspection",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "date",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/BeaverDamsReport/ONR_BeaverDamsReportSchema.js